// Autogenerated file
export const shippingOrderTitleTypesEnum = {
    T1: "T1",
    T2: "T2",
};
export const shippingOrderTitleTypes = [
    { label: "Т1 - получена заказ-заявка", value: "T1" },
    { label: "Т2 - заказ-заявка утверждена", value: "T2" },
];
